import React from 'react';
import Balancer from 'react-wrap-balancer';
import { useTheme } from 'next-themes';
import dynamic from 'next/dynamic';
import cn from 'classnames';
import rehypeRaw from 'rehype-raw';
import { CTA, AnchorArrow } from 'react-scale/components';

const ReactMarkdown = dynamic(import('react-markdown'), {
  ssr: false
});

const SectionTitle = ({
  overtitle,
  title,
  product,
  subtitle,
  marginBottom,
  link,
  centered,
  themeColors,
  theme,
  overtitleClassName,
  fullWidth,
  cta
}) => {
  return (
    <div
      className={cn(
        { 'md:max-w-4xl': !fullWidth },
        { 'w-full': fullWidth },
        {
          'text-center': centered,
          'mb-24': marginBottom
        }
      )}
    >
      {overtitle && (
        <h2
          style={{ color: themeColors?.overtitleColor }}
          className={cn(
            'inline-block uppercase tracking-[4px] text-sm mb-5',
            !themeColors?.overtitleColor,
            overtitleClassName,
            useTheme().forcedTheme === 'light' || useTheme().resolvedTheme === 'light'
              ? 'text-gradient'
              : 'dark-text-gradient'
          )}
        >
          {overtitle}
        </h2>
      )}
      <h1 className={cn(titleTheme[theme], 'font-aeonik mb-6 w-full', 'text-4xl lg:text-5xl')}>
        <Balancer ratio={0.4}>
          {title} {product && <span className="text-gradient">{product}</span>}
        </Balancer>
      </h1>
      {subtitle && (
        <div className={cn(textTheme[theme], 'text-xl')}>
          <Balancer ratio={0.4}>
            <ReactMarkdown rehypePlugins={[rehypeRaw]}>{subtitle}</ReactMarkdown>
          </Balancer>
        </div>
      )}
      {link?.text && (
        <div className="mt-8 text-lg">
          <AnchorArrow
            href={link.href}
            text={link.text}
            openInNewTab={link.openInNewTab}
            theme="light"
            textColor={linkTheme[theme]}
          />
        </div>
      )}
      {cta && (
        <div className="mt-10">
          <CTA cta={cta} theme={theme} />
        </div>
      )}
    </div>
  );
};

const titleTheme = {
  dark: 'text-white',
  light: 'text-black'
};

const textTheme = {
  dark: 'text-neutral-300',
  light: 'text-neutral-600'
};

const linkTheme = {
  dark: 'text-scale-skyblue',
  light: 'text-malibu'
};

SectionTitle.defaultProps = {
  theme: 'dark',
  centered: false,
  overtitle: '',
  title: 'Title',
  marginBottom: true,
  themeColors: undefined,
  overtitleClassName: '',
  fullWidth: false
};

export default SectionTitle;
